import useStore from "../hooks/useStore";
import NewBadge from "./NewBadge";

const nasbaLevels: any = {
  1: "Basic",
  2: "Intermediate",
  3: "Advanced",
  4: "Overview",
  5: "Update",
};

const WebinarHeader = () => {
  const activeWebinar = useStore((state) => state.activeWebinar);
  const rating = Number(activeWebinar.EvaluationRating);
  const nasbaLevelId = activeWebinar.LearningLevelID;

  const renderStars = () => {
    const flooredRating = Math.floor(rating);
    const ceiledRating = Math.ceil(rating);

    return [...Array(5)].map((_, i) => {
      const starPosition = i + 1;
      const offset = (rating - flooredRating) * 100;

      if (starPosition <= flooredRating) {
        return (
          <svg
            key={i}
            className="tw-w-6 tw-h-6 tw-text-tr"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
          </svg>
        );
      }

      if (starPosition === ceiledRating) {
        return (
          <svg
            key={i}
            className="tw-w-6 tw-h-6"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
              fill={`url(#gradient--${i})`}
            ></path>

            <defs>
              <linearGradient
                id={`gradient--${i}`}
                x1={`${offset}%`}
                y1="0%"
                x2="100%"
                y2="0%"
              >
                <stop
                  offset="0%"
                  style={{ stopColor: "#FF5900", stopOpacity: 1 }}
                ></stop>
                <stop
                  offset="1%"
                  style={{ stopColor: "#626369", stopOpacity: 0.3 }}
                ></stop>
              </linearGradient>
            </defs>
          </svg>
        );
      }

      return (
        <svg
          key={i}
          className="tw-w-6 tw-h-6 tw-text-tr-date/30"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
        </svg>
      );
    });
  };

  return (
    <div className="tw-grid tw-grid-cols-1 tw-gap-y-6">
      <a
        href={`/CourseFinder/CourseDetails/${activeWebinar.ID}`}
        target="_blank"
        rel="noopener noreferrer"
        className="tw-text-2xl md:tw-text-3xl xl:tw-text-4xl tw-text-tr-black tw-font-medium tw-cursor-pointer focus:tw-outline-none"
      >
        {activeWebinar?.CourseTitle}
        {activeWebinar?.IsNew && <NewBadge />}
      </a>
      <div className="tw-border-y tw-py-4 tw-text-tr-date/75 tw-flex tw-flex-col md:tw-flex-row tw-items-start md:tw-items-center tw-justify-between tw-uppercase">
        <span>
          course id: {activeWebinar?.Acronym}, version{" "}
          {activeWebinar?.CurrentVersionNumber}
        </span>
        <span>
          category:{" "}
          <span
            dangerouslySetInnerHTML={{
              __html: activeWebinar?.FieldOfStudyName,
            }}
          ></span>
        </span>
        <span>level: {nasbaLevels[nasbaLevelId]}</span>
        <div className="tw-flex tw-items-center tw-justify-center tw-hidden">
          {rating === 0 ? (
            <div className="tw-text-white tw-select-none">
              Rating not available
            </div>
          ) : (
            renderStars()
          )}
        </div>
      </div>
    </div>
  );
};

export default WebinarHeader;
